import { Box, Typography } from '@mui/material'
import React from 'react'

function DetailData({dataName,data}) {
  return (
    <>
        <Box >
            <Typography variant='h4'>{dataName}</Typography>
            <Typography variant='h7' color='shade.light'>{data}</Typography>
        </Box>
    </>
  )
}

export default DetailData